module.exports = __webpack_public_path__ + "img/21.437f0c70.png";